import { useQuery, } from "@tanstack/react-query";
import { operationsQueryConfig, } from "../../../api";
import { OperationsListView, } from "./OperationsListView.tsx";

export interface IOperationsListDefault {
  emptyBlockVariant?: "default" | "tiny";
}

export function OperationsListDefault({ emptyBlockVariant = "default", }: IOperationsListDefault,) {
  const operations = useQuery(operationsQueryConfig(),);

  return (
    <OperationsListView
      isLoading={operations.isLoading}
      isSuccess={operations.isSuccess}
      data={operations.data?.data}
      emptyBlockVariant={emptyBlockVariant}
    />
  );
}
